/**
 * observes elements with a given class and triggers a callback when the element is visible, removing the (potentially) set hide-class
 */
export default class Animate {
    constructor(animation_class) {
        var elements = document.querySelectorAll(animation_class);
        elements.forEach(elem => {
            this.triggerOnVisible(elem, this.fadeIn);
        });

        this.debug = window.location.hostname === "typo3.2024.ferienregion-nationalpark.de.ddev.site" ? true : false;
        if(this.debug) {
            console.debug("Animation-dbg: activated..");
        }
    }

    triggerOnVisible(element, callback) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback(entry.target);
                    observer.unobserve(entry.target);
                    if(this.debug) {
                        console.debug("Animation-dbg: triggerOnVisible", entry.target);
                    }
                }
            });
        }, { threshold: [0] });
        observer.observe(element);
    }

    fadeIn(element) {
        element.classList.remove("cls-hide");
    }
}
